"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.workerCertificateTag = exports.MAX_WORKER_ID_LENGTH = exports.WORKER_ID_PATTERN = exports.WORKER_PII_FIELDS = exports.ACCESS_CODE_LENGTH_TYPE = void 0;
exports.ACCESS_CODE_LENGTH_TYPE = {
    SHORT: 8,
    LONG: 16,
};
exports.WORKER_PII_FIELDS = ['name', 'phone_number', 'id_details', 'upi', 'bank_account'];
exports.WORKER_ID_PATTERN = /^\d+$/;
exports.MAX_WORKER_ID_LENGTH = 20;
exports.workerCertificateTag = '__WORKER_CERTIFICATE__';
//# sourceMappingURL=Index.js.map